/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

// react and redux
import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import useInstance from "../../actions/useInstance";
// BASE Components
import BASEPageSimple from "../../../@BASE/core/BASEPageSimple";
import BASELoading from "../../../@BASE/core/BASELoading";
import useThemeMediaQuery from "../../../@BASE/hooks/useThemeMediaQuery";
// material-ui components
import { styled } from "@mui/material/styles";
// custom components
import InstanceHeader from "../headers/InstanceHeader"
// styles to add to the page layout
const Root = styled(BASEPageSimple)(({ theme }) => ({
  "& .BASEPageSimple-header": {
    backgroundColor: theme.palette.background.royalBlue,
    color: theme.palette.getContrastText(theme.palette.primary.main),
  },
  "&.BASEPageSimple-production .BASEPageSimple-header": {
    backgroundColor: theme.palette.background.imiPurple,
  },
  "&.BASEPageSimple-qa .BASEPageSimple-header": {
    backgroundColor: theme.palette.background.qaRed,
    color: '#000000',
  },
  "& .html-reset ul, & .html-reset ol": {
    listStyle: "auto",
    margin: "revert",
    padding: "revert",
  },
}));


const InstanceWrapper = () => {
  // set breakpoint for mobile
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));
  // get route information
  const routeParams = useParams();
  const location = useLocation();
  // get the resource from the location pathname
  const { pathname } = location;
  // split the pathname into an array
  const pathArray = pathname.split("/");
  // path variables
  const resource = pathArray[1];
  const id = routeParams.id;
  const action = pathArray.length >= 4 ? pathArray[3] : 'view';
  // instance hook
  const { instance, instanceDetails, handleInstanceAction, loading, error, setError } = useInstance(resource, id, action);
  // form state for buttons
  const [onSave, setOnSave] = useState(null);
  const [saveDisabled, setSaveDisabled] = useState(true);

  // if loading, show loading spinner
  if (loading || !instance || !instanceDetails) {
    return <BASELoading />;
  }

  return (
    <Root
      header={
        resource === 'pages' && action !== 'edit' ? null :
        <InstanceHeader
          instance={instance}
          details={instanceDetails}
          resource={resource}
          action={action}
          onSave={onSave}
          save_disabled={saveDisabled}
          handleInstanceAction={handleInstanceAction}
        />
      }
      content={
        <div className="container">
          <Outlet context={{instance, handleInstanceAction, loading, setOnSave, setSaveDisabled, error, setError}} />
        </div>
      }
      className={action === 'imi-comments' ? 'BASEPageSimple-production' : action === 'pre-trial-comments' ? 'BASEPageSimple-qa' : ''}
      scroll={isMobile ? "normal" : "normal"}
    />
  );
};

export default InstanceWrapper;
